import React, { useState } from 'react';

import { FiTruck } from 'react-icons/fi';
import Header from '../../layouts/Header';
import Filter from '../../helpers/filter/Filter';
import classes from '../../assets/Global.module.css';
import Create from '../../helpers/panel/Create';
import CreateTrailer from '../../features/creates/trailer/Trailer';
import { RiListCheck } from 'react-icons/ri';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { VscSearch } from 'react-icons/vsc';

function Trailer() {
  const [filterValue, setFilterValue] = useState('');

  const navigate = useNavigate();
  const pathName = useLocation().pathname.split('/').slice(-1)[0];

  return (
    <>
      <h1>Trailers</h1>
      <Header>
        <div>
          <button onClick={() => Create(<CreateTrailer />)}>
            <FiTruck />
            <span>Create a Trailer</span>
          </button>
          <button
            onClick={() => navigate('/asset/trailer')}
            className={pathName === 'trailer' ? classes.buttonActive : ''}
          >
            <RiListCheck />
            <span>Trailer Board</span>
          </button>
          <button
            onClick={() => navigate('/asset/trailer/search')}
            className={pathName === 'search' ? classes.buttonActive : ''}
          >
            <VscSearch />
            <span>Search Trailers</span>
          </button>
        </div>
        <div>
          <Filter
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            placeholder="Filter trailers"
          />
        </div>
      </Header>
      <Outlet context={filterValue} />
    </>
  );
}

export default Trailer;
